// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.championship-card_icon__u6QNY {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background-color: var(--white-text-color);
  display: flex;
  align-items: center;
  justify-content: center;
}

.championship-card_header__RVUTM {
  display: grid;
  grid-template-columns: min-content 1fr min-content;
  gap: 12px;
  align-items: center;
}

.championship-card_title__bqsSC {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.championship-card_data__wAyLQ {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.championship-card_grey-title__srPyB {
  font-size: 14px;
  font-weight: 600;
  color: var(--secondary-accent-text-color);
}

.championship-card_item__Jlus5 {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.championship-card_value__TfguS {
  display: flex;
  align-items: center;
  gap: 8px;
}

.championship-card_captains__niDlp {
  display: flex;
  gap: 4px;
}

.championship-card_actions__ziODY {
  display: flex;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/components/teams/championship-card.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B","sourcesContent":[".icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  background-color: var(--white-text-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.header {\n  display: grid;\n  grid-template-columns: min-content 1fr min-content;\n  gap: 12px;\n  align-items: center;\n}\n\n.title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.data {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.grey-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--secondary-accent-text-color);\n}\n\n.item {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.value {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.captains {\n  display: flex;\n  gap: 4px;\n}\n\n.actions {\n  display: flex;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `championship-card_icon__u6QNY`,
	"header": `championship-card_header__RVUTM`,
	"title": `championship-card_title__bqsSC`,
	"data": `championship-card_data__wAyLQ`,
	"grey-title": `championship-card_grey-title__srPyB`,
	"item": `championship-card_item__Jlus5`,
	"value": `championship-card_value__TfguS`,
	"captains": `championship-card_captains__niDlp`,
	"actions": `championship-card_actions__ziODY`
};
export default ___CSS_LOADER_EXPORT___;
